import { useCallback, useState } from 'react';
import { ApiError } from '@vanialabs/core-api';

import {
  createTenantDomain,
} from '../api/tenant-domains.api';
import type {
  CreateTenantDomainInput,
  TenantDomain,
} from '../types/tenant-domain.types';

function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const body = error.body as {
      code?: unknown;
      error_code?: unknown;
      detail?: unknown;
    } | undefined;
    const detail = body?.detail;
    const detailObject = typeof detail === 'object' && detail !== null
      ? detail as { code?: unknown; error_code?: unknown }
      : undefined;
    const errorCode = body?.error_code ?? body?.code ??
      detailObject?.error_code ?? detailObject?.code;

    if (errorCode === 'DOMAIN_ALREADY_EXISTS') {
      return 'این دامنه قبلاً ثبت شده است.';
    }

    if (typeof detail === 'string' && /domain already exists/i.test(detail)) {
      return 'این دامنه قبلاً ثبت شده است.';
    }

    if (typeof detail === 'string' && detail.trim()) return detail;
  }
  return 'خطا در ایجاد دامنه تننت. لطفاً دوباره تلاش کنید.';
}

export function useCreateTenantDomain(tenantId: number | string) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (input: CreateTenantDomainInput): Promise<TenantDomain> => {
    setSubmitting(true);
    setError(null);

    try {
      return await createTenantDomain(tenantId, input);
    } catch (requestError) {
      setError(errorMessage(requestError));
      throw requestError;
    } finally {
      setSubmitting(false);
    }
  }, [tenantId]);

  const resetError = useCallback(() => setError(null), []);

  return { submit, submitting, error, resetError };
}
